import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
import { withRouter } from 'utils';
import { Typography, Tabs, Tab } from '@mui/material';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.palette.primary.accent,
  },
  header: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
  },
  tabs: {
    paddingTop: 3,
    paddingLeft: theme.spacing(3),
  },
  indicator: {
    backgroundColor: '#FFFFFF',
    height: 2,
    marginBottom: 8,
  },
  headerDivider: {},
  tabPanel: {
    color: '#E0E0E0',
    '&.Mui-selected': {
      color: '#FFFFFF',
    },
    '&:hover': {
      color: '#FFFFFF',
    },
  },
});

// The routes that back each tab. `value` is the route segment (no leading slash);
// `label` is what admins see. Order follows the grouping requested for Admin Tools.
const ADMIN_TOOLS_TABS = [
  { value: 'clients', label: 'Clients' },
  { value: 'users', label: 'Users' },
  { value: 'announcements', label: 'Announcements' },
  { value: 'taxonomy', label: 'Specialties' },
  { value: 'upload', label: 'Upload' },
  { value: 'login_settings', label: 'Login Settings' },
];

class AdminToolsTabs extends React.Component {
  render() {
    const { tab, classes } = this.props;

    return (
      <div className={classes.container}>
        <title>Admin Tools</title>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>Admin Tools</Typography>
        </div>
        <Tabs
          variant='scrollable'
          TabIndicatorProps={{ className: classes.indicator }}
          className={classes.tabs}
          value={tab}
          onChange={this.onTabChange}
        >
          {ADMIN_TOOLS_TABS.map((t) => (
            <Tab
              key={t.value}
              className={classes.tabPanel}
              label={t.label}
              value={t.value}
              disableRipple
            />
          ))}
        </Tabs>
      </div>
    );
  }

  onTabChange = (event, newValue) => {
    this.props.router.navigate(`/${newValue}`);
  };
}

AdminToolsTabs.propTypes = {
  router: PropTypes.object.isRequired,
  classes: PropTypes.object,
  tab: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

const styled = withStyles(styles)(AdminToolsTabs);
const connected = connect(mapStateToProps)(styled);
const routed = withRouter(connected);
export { routed as AdminToolsTabs };
export default routed;
